import axios from "../axios";

export async function printQualityInstruction(payload) {
  return axios.put(`/quality/instructions/${payload.id}/print`, {
    printType: payload.printType || payload.print_type || "standard",
    include_images: payload.include_images || false,
  });
}

export async function fetchQualityInstructions(controller) {
  return axios({
    method: "get",
    url: "quality/instructions",
    params: controller,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export async function fetchQualityInstruction(id) {
  return axios.get(`/quality/instructions/` + id);
}

export async function createQualityInstruction(payload) {
  return axios
    .post(`/quality/instructions`, { instruction: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function updateQualityInstruction(payload) {
  return axios
    .put(`/quality/instructions/${payload.id}`, { instruction: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteQualityInstruction(payload) {
  const instruction = payload.instruction;
  return axios
    .delete(`/quality/instructions/${instruction.id}`, {
      data: JSON.stringify({
        instruction,
      }),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

// Revision functions
export async function createInstructionRevision(instructionId) {
  return axios
    .post(`/quality/instructions/${instructionId}/create_revision`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function approveInstructionRevision(instructionId, revisionId) {
  return axios
    .post(`/quality/instructions/${instructionId}/approve_revision`, {
      revision_id: revisionId,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function fetchInstructionRevisions(instructionId) {
  return axios
    .get(`/quality/instructions/${instructionId}/revisions`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchInstructionRevision(instructionId, revisionId) {
  return axios
    .get(`/quality/instructions/${instructionId}/revisions/${revisionId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function updateInstructionRevision(instructionId, revisionId, payload) {
  return axios
    .put(`/quality/instructions/${instructionId}/revisions/${revisionId}`, {
      revision: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function approveInstructionRevisionUser(instructionId, revisionId, approved, comment) {
  return axios
    .post(`/quality/instructions/${instructionId}/revisions/${revisionId}/approve_user`, {
      approved: approved,
      comment: comment || "",
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function notifyUsersAboutRevision(instructionId, revisionId, userIds) {
  return axios
    .post(`/quality/instructions/${instructionId}/revisions/${revisionId}/notify_users`, {
      user_ids: userIds,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function exportInstructionRevisionPDF(instructionId, revisionId) {
  return axios
    .get(`/quality/instructions/${instructionId}/revisions/${revisionId}/export_pdf`, {
      responseType: 'blob',
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
